<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ZBREAK"></p>
<p class="TITLE" id="toc_marker-1">Distance in Preaching</p>
<p class="SUBTITLE">Room to Speak, Space to Listen</p>
<p class="AUTHOR">Michael Brothers</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brothers_Distance_in_Preaching_text.vue?50e3540a